var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _rect11, _rect12, _polygon, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path24, _path25, _path26, _path27, _path28, _ellipse, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse2, _path35, _ellipse3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _rect28, _rect29, _path72, _path73, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fafcfc;}.cls-3{fill:#cccdd2;}.cls-4{fill:#fff;}.cls-5,.cls-6{fill:#784cfb;}.cls-5{stroke:#5d4f9a;stroke-miterlimit:10;}.cls-7{clip-path:url(#clip-path);}.cls-8{fill:#732313;}.cls-9{fill:#f5ba93;}.cls-10{fill:#e55747;}.cls-11{fill:#da9b7e;}.cls-12{fill:#cb4639;}.cls-13{fill:#e44e40;}.cls-14{fill:#2d120e;}.cls-15{fill:#170000;}.cls-16{fill:#b0afb5;}.cls-17{fill:#d8dade;}.cls-18{fill:#c3c5ca;}.cls-19{clip-path:url(#clip-path-2);}.cls-20{fill:#51361d;}.cls-21{fill:#9d6b3f;}.cls-22{fill:#5ab9bd;}.cls-23{fill:#815931;}.cls-24{fill:#843921;}.cls-25{clip-path:url(#clip-path-3);}.cls-26{fill:#de8021;}.cls-27{fill:#f2d4b6;}.cls-28{fill:#b3211b;}.cls-29{fill:#e24e70;}.cls-30{fill:#e56681;}.cls-31{fill:#737277;opacity:0.07;isolation:isolate;}.cls-32{fill:#e1ab81;}.cls-33{fill:#ce966d;}.cls-34{fill:#434041;}.cls-35{fill:#40290f;}.cls-36{fill:#89878c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.68,157.49a30,30,0,1,1-30-30A30,30,0,0,1,119.68,157.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 318.09,
    cy: 194.15,
    r: 24.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 261.65,
    cy: 75.85,
    r: 20.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 425.2,
    height: 425.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.6,219.75a14,14,0,0,1-14,14H65.56a14,14,0,0,1-14-14V109.48a14,14,0,0,1,14-14h97.06a14,14,0,0,1,14,14V219.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.2,218a14,14,0,0,1-14,14H64.16a14,14,0,0,1-14-14V107.73a14,14,0,0,1,14-14h97.06a14,14,0,0,1,14,14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.2,114.72v-7a14,14,0,0,0-14-14H64.16a14,14,0,0,0-14,14v7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.41,108.82a1.14,1.14,0,0,1-1.14,1.14h-7.62a1.15,1.15,0,0,1-1.14-1.14V101.2a1.14,1.14,0,0,1,1.14-1.14h7.62a1.14,1.14,0,0,1,1.14,1.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.78,108.82a1.14,1.14,0,0,1-1.14,1.14H154a1.15,1.15,0,0,1-1.14-1.14V101.2a1.14,1.14,0,0,1,1.14-1.14h7.61a1.14,1.14,0,0,1,1.14,1.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.91,105a5,5,0,0,1-5,4.95H62.9A5,5,0,0,1,58,105h0a4.94,4.94,0,0,1,4.95-5H127a5,5,0,0,1,5,5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-6",
    d: "M119.68,157.49a30,30,0,1,1-30-30A30,30,0,0,1,119.68,157.49Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.7,174.73c1,4.43-30.25,3.94-30.25,0,4.87-8.41.16-14-.41-25.11s29.85-8.09,30.49,0S100.44,168.84,104.7,174.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.24,195.45h4.48l-.12-1.58s-.49-13.89-1-17.79S99,172.22,99,172.22l-2.23,6.54s2,12.35,2.22,15C99,194.12,99.1,194.71,99.24,195.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M78.32,195.45c.16-.81.27-1.45.31-1.86.24-2.64,2.23-15,2.23-15l-2.23-6.54s-3.07,0-3.61,3.86-1,17.79-1,17.79l-.13,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.14,190l1.21,5.41H97.29l1.8-5.41s2.84-2.1,2.81-4-3.62-7.24-3.62-7.24l1.25-6.68-5.35-2.52H83.78L78.55,172l1.08,6.8s-2.91,5.13-2.95,7.24S79.14,190,79.14,190Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.17,169.55s1.89,7.39.87,9.28c-1.15,2.13-10.45,1.95-11.7,0s.43-9.28.43-9.28l1.6-.08v-7.8h7.15v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M91.32,168.4a11.31,11.31,0,0,0,1.2-.42v-6.31H85.37v5.69C87.26,168.25,89.11,169,91.32,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.58,157.37a2.66,2.66,0,0,1-2.12-.29s-5,.26-5-1.05v-4.4c0-3.13,5-2.82,5-2.82a1.9,1.9,0,0,1,2.66-.51C107.53,150,106.46,156.57,104.58,157.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.81,157.37a2.66,2.66,0,0,0,2.12-.29s5,.26,5-1.05v-4.4c0-3.13-5-2.82-5-2.82a1.9,1.9,0,0,0-2.66-.51C71.86,150,72.92,156.57,74.81,157.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102.58,155.57c0,5.83-8.44,12.29-13,12.29-5,0-13-6.88-13-12.66V143c0-17.22,25.93-18.36,25.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M77.44,149c-.09-1.64,2.63-3,2.9-8.94,2.26,1.25,13.19,7.67,21.45,8.91a13.17,13.17,0,0,0,1,5.6s0-3,0-4.54,1.94-2.09,1.94-2.09v-5.31c0-2.85-2.92-16.1-15.15-13-11.65-2.7-16.92,9.53-16.68,12.53s.57,7.08.57,7.08,2.67-2.48,3,.94c.2,1.84,0,3.78,1.37,4.08C77.67,152.61,77.55,151.08,77.44,149Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "89.37 149.88 89.37 158.42 90.87 157.24 89.37 149.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.12,148.2s-2.29-1.54-3.76-1.06a12.81,12.81,0,0,0-3.29,2.07l-.2-.75a5.41,5.41,0,0,1,3.35-1.81A6.11,6.11,0,0,1,87.12,148.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.85,161.42s1.21,1.16,1.9,1.21a16.48,16.48,0,0,0,4.06-.13,8.57,8.57,0,0,0,1.29-1.06l-3.43-.17C89.15,161.25,85.85,161.42,85.85,161.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M83.92,160.52a9.26,9.26,0,0,0,2.49.57c.71-.08,1.91-1.09,2.19-1l1,.42a3.88,3.88,0,0,1,1.21-.42c.28.05,1.76,1,2.28,1a11.15,11.15,0,0,0,1.72-.57,13.16,13.16,0,0,1-2.08,1.16,8,8,0,0,1-3-.07c-.94-.06-2.3.6-3.37,0S83.92,160.52,83.92,160.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.27,148.06S94.56,146.51,96,147a12.81,12.81,0,0,1,3.29,2.07l.2-.76a5.41,5.41,0,0,0-3.36-1.82A6.1,6.1,0,0,0,92.27,148.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M95.45,149.49c1.67,0,1.42,1.24,2,1.58.15-.09,1.07-.4,1.07-.4a3.52,3.52,0,0,0-3-1.48,3.3,3.3,0,0,0-2.93,1.45,1.24,1.24,0,0,1,.48.09C93.54,150.39,93.78,149.49,95.45,149.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.07,150.67s-.34,1.26-2.48,1.26a3.64,3.64,0,0,1-3-1.29,3.7,3.7,0,0,1,3-1.23C97.72,149.41,98.07,150.67,98.07,150.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.12,150.64a1.52,1.52,0,0,0,.62,1.22,5.07,5.07,0,0,0,1.68,0,1.51,1.51,0,0,0,0-2.44,5.91,5.91,0,0,0-1.68,0A1.52,1.52,0,0,0,94.12,150.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.18,150.67a.6.6,0,0,1-.6.6.59.59,0,0,1-.59-.6.6.6,0,1,1,1.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.43,150.1a.26.26,0,0,1-.27.26.27.27,0,1,1,0-.53A.28.28,0,0,1,95.43,150.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.6,150.68a.14.14,0,0,1-.28,0,.14.14,0,0,1,.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M83.93,149.49c-1.67,0-1.42,1.24-2,1.58-.15-.09-1.07-.4-1.07-.4a3.52,3.52,0,0,1,3-1.48,3.3,3.3,0,0,1,2.93,1.45,1.24,1.24,0,0,0-.48.09C85.85,150.39,85.61,149.49,83.93,149.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.32,150.67s.34,1.26,2.48,1.26a3.64,3.64,0,0,0,3-1.29,3.7,3.7,0,0,0-3-1.23C81.67,149.41,81.32,150.67,81.32,150.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M85.26,150.64a1.52,1.52,0,0,1-.62,1.22,5.07,5.07,0,0,1-1.68,0,1.51,1.51,0,0,1,0-2.44,5.91,5.91,0,0,1,1.68,0A1.49,1.49,0,0,1,85.26,150.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M83.21,150.67a.59.59,0,1,0,.59-.6A.59.59,0,0,0,83.21,150.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84,150.1a.26.26,0,0,0,.27.26.27.27,0,1,0,0-.53A.28.28,0,0,0,84,150.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.79,150.68a.14.14,0,0,0,.14.14.14.14,0,0,0,.14-.14.15.15,0,0,0-.14-.14A.14.14,0,0,0,83.79,150.68Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 124.64,
    y: 129.72,
    width: 40.27,
    height: 7.62
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 142.78,
    width: 40.27,
    height: 3.81
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 150.58,
    width: 40.27,
    height: 3.81
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 158.38,
    width: 40.27,
    height: 3.81
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 166.17,
    width: 40.27,
    height: 3.81
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 173.98,
    width: 40.27,
    height: 3.81
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 124.64,
    y: 181.77,
    width: 40.27,
    height: 3.81
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 65.14,
    y: 197.74,
    width: 99.77,
    height: 3.81
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 65.14,
    y: 207.18,
    width: 99.77,
    height: 3.81
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M382.21,149.25a11.53,11.53,0,0,0-9.62-5.15H292.31a11.56,11.56,0,0,0-11.56,11.56v91.2a14.06,14.06,0,0,0,12.72,13h80.28a11.56,11.56,0,0,0,11.56-11.56v-91.2A11.47,11.47,0,0,0,382.21,149.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390,245.64a11.57,11.57,0,0,1-11.56,11.56H298.14a11.56,11.56,0,0,1-11.56-11.56v-91.2a11.57,11.57,0,0,1,11.56-11.56h80.28A11.56,11.56,0,0,1,390,154.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.82,244.19a11.56,11.56,0,0,1-11.56,11.56H297a11.55,11.55,0,0,1-11.56-11.56V153A11.56,11.56,0,0,1,297,141.43h80.28A11.56,11.56,0,0,1,388.82,153Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.82,158.77V153a11.56,11.56,0,0,0-11.56-11.56H297A11.56,11.56,0,0,0,285.42,153v5.78Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.66,153.89a1,1,0,0,1-1,1h-6.3a1,1,0,0,1-.94-1v-6.3a.94.94,0,0,1,.94-.94h6.3a1,1,0,0,1,1,.94Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.54,153.89a1,1,0,0,1-1,1h-6.3a1,1,0,0,1-.94-1v-6.3a.94.94,0,0,1,.94-.94h6.3a1,1,0,0,1,1,.94Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353,150.74a4.09,4.09,0,0,1-4.09,4.09H296a4.1,4.1,0,0,1-4.1-4.09h0a4.09,4.09,0,0,1,4.1-4.09h53a4.09,4.09,0,0,1,4.09,4.09Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-6",
    d: "M342.9,194.15a24.81,24.81,0,1,1-24.81-24.81A24.81,24.81,0,0,1,342.9,194.15Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M322.9,217c.86,4-12.4,1.14-12.4-2.43,4.42-7.63-6.28-8.21-6.61-24.77-.2-10.07,27.58-7.36,27.66,0C331.71,204.49,319,211.68,322.9,217Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M326.76,231.41h4.06l-.11-1.44s-.44-12.6-.93-16.14-3.27-3.5-3.27-3.5l-2,5.93s1.8,11.2,2,13.6C326.54,230.2,326.63,230.74,326.76,231.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M307.78,231.41c.14-.73.25-1.32.28-1.69.22-2.4,2-13.6,2-13.6l-2-5.93s-2.79,0-3.27,3.5-.93,16.14-.93,16.14l-.12,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.52,226.5l1.09,4.91H325l1.63-4.91s2.57-1.91,2.55-3.67-3.28-6.57-3.28-6.57L327,210.2l-4.86-2.29h-9.44L308,210.1l1,6.17s-2.64,4.65-2.68,6.57S308.52,226.5,308.52,226.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M322.15,207.9s1.71,6.71.78,8.43c-1,1.93-9.48,1.77-10.61,0s.39-8.43.39-8.43l1.45-.07v-7.07h6.49v6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M319.57,206.86c.38-.11.74-.24,1.09-.38v-5.72h-6.49v5.17C315.89,206.73,317.56,207.43,319.57,206.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M331.6,196.86a2.4,2.4,0,0,1-1.92-.27s-4.57.24-4.57-1v-4c0-2.84,4.57-2.56,4.57-2.56a1.73,1.73,0,0,1,2.42-.46C334.28,190.19,333.31,196.14,331.6,196.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.59,196.86a2.4,2.4,0,0,0,1.92-.27s4.57.24,4.57-1v-4c0-2.84-4.57-2.56-4.57-2.56a1.73,1.73,0,0,0-2.42-.46C301.91,190.19,302.87,196.14,304.59,196.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M329.79,195.22c0,5.29-7.66,11.16-11.76,11.16-4.52,0-11.76-6.24-11.76-11.48V183.84c0-15.63,23.53-16.66,23.53,0C329.79,194.45,329.79,187.63,329.79,195.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307,189.26c-.08-1.49,8.3-3.54,10.58-10,2.21,5.6,4,8.89,11.51,10a11.94,11.94,0,0,0,.88,5.08s0-2.72,0-4.12,1.76-1.9,1.76-1.9v-4.82c0-2.58-2.65-14.61-13.75-11.79-10.57-2.45-15.14,7.76-15.13,11.37a56.53,56.53,0,0,0,.52,6.43s2.42-2.25,2.75.85c.18,1.67,0,3.43,1.24,3.7C307.19,192.54,307.08,191.15,307,189.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "317.8 190.06 317.8 197.81 319.17 196.74 317.8 190.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M315.76,188.54s-2.08-1.4-3.41-1a11.63,11.63,0,0,0-3,1.88l-.18-.69a4.92,4.92,0,0,1,3-1.64A5.55,5.55,0,0,1,315.76,188.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M314.61,200.53s1.1,1.06,1.72,1.1a15.35,15.35,0,0,0,3.68-.12,7.31,7.31,0,0,0,1.17-1l-3.11-.15C317.6,200.38,314.61,200.53,314.61,200.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M312.86,199.72a8.26,8.26,0,0,0,2.26.51c.64-.07,1.73-1,2-.87l.9.38a3.37,3.37,0,0,1,1.1-.38c.26,0,1.6.94,2.07.87a9.65,9.65,0,0,0,1.56-.51,12.29,12.29,0,0,1-1.89,1.05,7.22,7.22,0,0,1-2.77-.06c-.85-.06-2.09.54-3.05,0S312.86,199.72,312.86,199.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M320.43,188.41s2.08-1.4,3.41-1a11.44,11.44,0,0,1,3,1.88l.18-.69a4.92,4.92,0,0,0-3-1.64A5.55,5.55,0,0,0,320.43,188.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M323.32,189.7c1.52,0,1.28,1.13,1.77,1.43.13-.08,1-.36,1-.36a3.19,3.19,0,0,0-2.73-1.34,3,3,0,0,0-2.66,1.32,1.1,1.1,0,0,1,.43.08C321.58,190.53,321.8,189.7,323.32,189.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.69,190.77s-.31,1.14-2.25,1.14a3.28,3.28,0,0,1-2.73-1.17,3.33,3.33,0,0,1,2.73-1.12C325.37,189.63,325.69,190.77,325.69,190.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M322.11,190.75a1.38,1.38,0,0,0,.57,1.11,4.84,4.84,0,0,0,1.52,0,1.36,1.36,0,0,0,.57-1.11,1.32,1.32,0,0,0-.57-1.1,4.77,4.77,0,0,0-.76-.06,4.68,4.68,0,0,0-.76.06A1.34,1.34,0,0,0,322.11,190.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M324,190.77a.54.54,0,1,1-.54-.54A.55.55,0,0,1,324,190.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.3,190.26a.24.24,0,0,1-.24.24.24.24,0,1,1,.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.46,190.79a.13.13,0,1,1-.13-.13A.13.13,0,0,1,323.46,190.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M312.87,189.7c-1.52,0-1.28,1.13-1.77,1.43-.13-.08-1-.36-1-.36a3.19,3.19,0,0,1,2.73-1.34,3,3,0,0,1,2.66,1.32,1.1,1.1,0,0,0-.43.08C314.61,190.53,314.39,189.7,312.87,189.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.5,190.77s.31,1.14,2.25,1.14a3.28,3.28,0,0,0,2.73-1.17,3.35,3.35,0,0,0-2.73-1.12C310.82,189.62,310.5,190.77,310.5,190.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M314.07,190.75a1.37,1.37,0,0,1-.56,1.11,4.77,4.77,0,0,1-.76.06,4.68,4.68,0,0,1-.76-.06,1.34,1.34,0,0,1-.57-1.11,1.32,1.32,0,0,1,.57-1.1,4.84,4.84,0,0,1,1.52,0A1.34,1.34,0,0,1,314.07,190.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M312.21,190.77a.54.54,0,1,0,.54-.54A.55.55,0,0,0,312.21,190.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.89,190.26a.24.24,0,0,0,.24.24.24.24,0,1,0-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.74,190.79a.13.13,0,0,0,.12.13.13.13,0,0,0,.13-.13.13.13,0,0,0-.13-.13A.12.12,0,0,0,312.74,190.79Z"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 347,
    y: 171.17,
    width: 33.31,
    height: 6.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 347,
    y: 181.98,
    width: 33.31,
    height: 3.15
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "380.31 191.58 370.7 191.58 347 191.58 347 188.43 380.31 188.43 380.31 191.58"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 347,
    y: 194.88,
    width: 33.31,
    height: 3.15
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 347,
    y: 201.33,
    width: 33.31,
    height: 3.15
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 347,
    y: 207.78,
    width: 33.31,
    height: 3.15
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 347,
    y: 214.23,
    width: 33.31,
    height: 3.15
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 297.79,
    y: 227.44,
    width: 82.52,
    height: 3.15
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 297.79,
    y: 235.24,
    width: 82.52,
    height: 3.15
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M314.74,40.3A9.54,9.54,0,0,0,306.79,36H240.44a9.55,9.55,0,0,0-9.55,9.55V121a9.51,9.51,0,0,0,2.56,6.49,9.53,9.53,0,0,0,8,4.26h66.35a9.55,9.55,0,0,0,9.55-9.56V46.79A9.51,9.51,0,0,0,314.74,40.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.05,118.4A9.56,9.56,0,0,1,311.5,128H245.15a9.55,9.55,0,0,1-9.55-9.56V43a9.56,9.56,0,0,1,9.55-9.56H311.5A9.55,9.55,0,0,1,321.05,43Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.1,117.21a9.55,9.55,0,0,1-9.55,9.55H244.2a9.55,9.55,0,0,1-9.55-9.55V41.83a9.55,9.55,0,0,1,9.55-9.55h66.35a9.55,9.55,0,0,1,9.55,9.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.1,46.61V41.83a9.55,9.55,0,0,0-9.55-9.55H244.2a9.55,9.55,0,0,0-9.55,9.55v4.78Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.79,42.58a.78.78,0,0,1-.78.78h-5.2a.78.78,0,0,1-.78-.78V37.37a.78.78,0,0,1,.78-.78H301a.78.78,0,0,1,.78.78Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.6,42.58a.78.78,0,0,1-.78.78h-5.21a.78.78,0,0,1-.78-.78V37.37a.78.78,0,0,1,.78-.78h5.21a.78.78,0,0,1,.78.78Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.5,40a3.38,3.38,0,0,1-3.38,3.38H243.33A3.38,3.38,0,0,1,240,40h0a3.38,3.38,0,0,1,3.38-3.38h43.79A3.37,3.37,0,0,1,290.5,40Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    className: "cls-6",
    d: "M282.15,75.85a20.5,20.5,0,1,1-20.5-20.5A20.5,20.5,0,0,1,282.15,75.85Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M268.43,83.68c-3.35,3-10.83,2.53-13.08.81S248.89,80.26,250.5,72s21.25-6.09,21.7,0S271.63,80.77,268.43,83.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M268.45,104.31h3.19l-.09-1.12s-.34-9.89-.73-12.67-2.57-2.75-2.57-2.75l-1.59,4.66s1.41,8.79,1.58,10.67C268.27,103.37,268.34,103.79,268.45,104.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M253.55,104.31c.11-.57.19-1,.22-1.32.17-1.88,1.58-10.67,1.58-10.67l-1.59-4.66s-2.19,0-2.57,2.75-.73,12.66-.73,12.66l-.09,1.23h3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M254.13,100.47l.86,3.85H267l1.28-3.85s2-1.49,2-2.88-2.58-5.16-2.58-5.16l.89-4.75-3.81-1.8h-7.4l-3.73,1.72.77,4.84s-2.07,3.65-2.1,5.16S254.13,100.47,254.13,100.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M264.83,85.88s1.34,5.26.62,6.61c-.82,1.51-7.44,1.39-8.33,0s.31-6.61.31-6.61l1.14-.54V80.27h5.09v4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M262.8,85.06a7.76,7.76,0,0,0,.85-.3V80.27h-5.09v4A5.87,5.87,0,0,0,262.8,85.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M272.24,77.21a1.9,1.9,0,0,1-1.51-.21s-3.59.19-3.59-.75V73.12c0-2.23,3.59-2,3.59-2a1.34,1.34,0,0,1,1.89-.36C274.34,72,273.59,76.65,272.24,77.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M251.05,77.21a1.9,1.9,0,0,0,1.51-.21s3.59.19,3.59-.75V73.12c0-2.23-3.59-2-3.59-2a1.34,1.34,0,0,0-1.89-.36C249,72,249.71,76.65,251.05,77.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M270.82,75.93c0,4.15-6,8.75-9.23,8.75-3.54,0-9.23-4.89-9.23-9V67c0-12.26,18.46-13.07,18.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M252.92,71.25c-.07-1.17,1.87-2.11,2.06-6.36,1.61.89,9.39,5.46,15.27,6.34a9.25,9.25,0,0,0,.69,4s0-2.13,0-3.23,1.39-1.49,1.39-1.49V66.71c0-2-2.08-11.46-10.79-9.25-8.29-1.92-12,6.78-11.87,8.92s.41,5,.41,5,1.9-1.76,2.16.67c.14,1.31,0,2.69,1,2.91C253.09,73.82,253,72.74,252.92,71.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "261.42 71.88 261.42 77.96 262.49 77.12 261.42 71.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M259.81,70.69s-1.63-1.1-2.67-.75a9.14,9.14,0,0,0-2.34,1.47l-.14-.54a3.85,3.85,0,0,1,2.39-1.29A4.3,4.3,0,0,1,259.81,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M258.91,80.09s.86.83,1.35.86a12.34,12.34,0,0,0,2.89-.09,5.9,5.9,0,0,0,.92-.75L261.63,80C261.26,80,258.91,80.09,258.91,80.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M257.54,79.45a6.29,6.29,0,0,0,1.77.4c.51-.06,1.36-.77,1.56-.68l.71.3a2.89,2.89,0,0,1,.86-.3c.2,0,1.25.73,1.62.68a7.75,7.75,0,0,0,1.22-.4,10.07,10.07,0,0,1-1.48.83,5.72,5.72,0,0,1-2.17,0c-.67,0-1.64.42-2.4,0S257.54,79.45,257.54,79.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M263.48,70.58s1.63-1.1,2.67-.75a9.14,9.14,0,0,1,2.34,1.47l.14-.54a3.85,3.85,0,0,0-2.39-1.29A4.36,4.36,0,0,0,263.48,70.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M265.75,71.6c1.19,0,1,.88,1.39,1.12a7,7,0,0,1,.76-.28,2.51,2.51,0,0,0-2.15-1.06,2.35,2.35,0,0,0-2.09,1,.91.91,0,0,1,.34.06C264.38,72.24,264.56,71.6,265.75,71.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.61,72.44s-.25.9-1.76.9a2.57,2.57,0,0,1-2.14-.92,2.63,2.63,0,0,1,2.14-.88C267.36,71.54,267.61,72.44,267.61,72.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M264.8,72.42a1.06,1.06,0,0,0,.44.87,3.62,3.62,0,0,0,1.2,0,1.06,1.06,0,0,0,.44-.87,1.08,1.08,0,0,0-.44-.87,3.86,3.86,0,0,0-.6,0,5.85,5.85,0,0,0-.6,0A1.08,1.08,0,0,0,264.8,72.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M266.26,72.44a.42.42,0,1,1-.42-.42A.42.42,0,0,1,266.26,72.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.73,72a.19.19,0,1,1-.19-.19A.19.19,0,0,1,265.73,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.85,72.45a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.1.1,0,0,1,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.55,71.6c-1.19,0-1,.88-1.39,1.12a7.8,7.8,0,0,0-.76-.28,2.51,2.51,0,0,1,2.15-1.06,2.35,2.35,0,0,1,2.09,1,.94.94,0,0,0-.34.06C258.91,72.24,258.74,71.6,257.55,71.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.69,72.44s.25.9,1.76.9a2.57,2.57,0,0,0,2.14-.92,2.61,2.61,0,0,0-2.14-.88C255.93,71.54,255.69,72.44,255.69,72.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M258.49,72.42a1.07,1.07,0,0,1-.45.87,3.83,3.83,0,0,1-.6,0,3.94,3.94,0,0,1-.6,0,1.07,1.07,0,0,1,0-1.74,3.86,3.86,0,0,1,.6,0,5.85,5.85,0,0,1,.6,0A1,1,0,0,1,258.49,72.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M257,72.44a.42.42,0,1,0,.42-.42A.42.42,0,0,0,257,72.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.57,72a.18.18,0,0,0,.19.19A.19.19,0,0,0,258,72a.2.2,0,0,0-.19-.19A.19.19,0,0,0,257.57,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.44,72.45a.09.09,0,0,0,.1.1.1.1,0,1,0-.1-.1Z"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 285.54,
    y: 56.86,
    width: 27.53,
    height: 5.21
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 65.79,
    width: 27.53,
    height: 2.61
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 71.12,
    width: 27.53,
    height: 2.61
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 76.46,
    width: 27.53,
    height: 2.6
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 81.79,
    width: 27.53,
    height: 2.6
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 87.12,
    width: 27.53,
    height: 2.6
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 285.54,
    y: 92.45,
    width: 27.53,
    height: 2.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 244.86,
    y: 103.37,
    width: 68.2,
    height: 2.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 244.86,
    y: 109.81,
    width: 68.2,
    height: 2.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M296.86,382.15c0,4.87-37.73,8.82-84.27,8.82s-84.27-4-84.27-8.82,37.73-8.82,84.27-8.82S296.86,377.28,296.86,382.15Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M290.19,382.15c0,4.49-34.74,8.12-77.6,8.12s-77.6-3.64-77.6-8.12,34.74-8.12,77.6-8.12S290.19,377.66,290.19,382.15Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329,382.15c0,6.73-52.13,12.19-116.44,12.19S96.16,388.88,96.16,382.15,148.29,370,212.6,370,329,375.42,329,382.15Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.82,382.15c0,6.2-48,11.22-107.22,11.22s-107.22-5-107.22-11.22,48-11.22,107.22-11.22S319.82,376,319.82,382.15Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M312,382.15c0,5.75-44.51,10.41-99.42,10.41s-99.42-4.66-99.42-10.41,44.51-10.4,99.42-10.4S312,376.4,312,382.15Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 212.6,
    cy: 382.15,
    rx: 90.92,
    ry: 9.51
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M250.23,382.15c0,2.18-16.85,3.94-37.64,3.94S175,384.33,175,382.15s16.85-3.94,37.64-3.94S250.23,380,250.23,382.15Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M247.26,382.15c0,2-15.52,3.63-34.66,3.63s-34.66-1.62-34.66-3.63,15.52-3.63,34.66-3.63S247.26,380.14,247.26,382.15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M244.74,382.15c0,1.86-14.39,3.36-32.14,3.36s-32.14-1.51-32.14-3.36,14.39-3.36,32.14-3.36S244.74,380.29,244.74,382.15Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M242,382.15c0,1.7-13.16,3.08-29.39,3.08s-29.39-1.38-29.39-3.08,13.16-3.08,29.39-3.08S242,380.45,242,382.15Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M264.21,382.15c0,3-23.11,5.4-51.61,5.4S161,385.13,161,382.15s23.11-5.4,51.61-5.4S264.21,379.17,264.21,382.15Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M260.13,382.15c0,2.75-21.28,5-47.53,5s-47.53-2.23-47.53-5,21.28-5,47.53-5S260.13,379.4,260.13,382.15Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 212.6,
    cy: 382.15,
    rx: 44.07,
    ry: 4.61
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M252.9,382.15c0,2.33-18,4.22-40.3,4.22s-40.3-1.89-40.3-4.22,18-4.22,40.3-4.22S252.9,379.82,252.9,382.15Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 212.6,
    cy: 382.15,
    rx: 71.32,
    ry: 7.46
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M278.27,382.15c0,3.8-29.4,6.87-65.67,6.87s-65.67-3.08-65.67-6.87,29.4-6.87,65.67-6.87S278.27,378.35,278.27,382.15Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M273.5,382.15c0,3.52-27.27,6.37-60.9,6.37s-60.9-2.85-60.9-6.37,27.27-6.37,60.9-6.37S273.5,378.63,273.5,382.15Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M268.29,382.15c0,3.22-24.93,5.83-55.69,5.83s-55.69-2.61-55.69-5.83,24.93-5.83,55.69-5.83S268.29,378.93,268.29,382.15Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M238.55,382.15c0,1.5-11.62,2.72-26,2.72s-25.95-1.22-25.95-2.72,11.62-2.72,25.95-2.72S238.55,380.65,238.55,382.15Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M236.26,382.15c0,1.37-10.59,2.48-23.66,2.48s-23.66-1.11-23.66-2.48,10.59-2.48,23.66-2.48S236.26,380.78,236.26,382.15Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M234.65,382.15c0,1.28-9.87,2.31-22.05,2.31s-22-1-22-2.31,9.87-2.31,22-2.31S234.65,380.87,234.65,382.15Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M232.91,382.15c0,1.17-9.09,2.13-20.31,2.13s-20.31-.95-20.31-2.13S201.38,380,212.6,380,232.91,381,232.91,382.15Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M231.43,382.15c0,1.09-8.43,2-18.83,2s-18.83-.88-18.83-2,8.43-2,18.83-2S231.43,381.06,231.43,382.15Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M229.82,382.15c0,1-7.71,1.8-17.22,1.8s-17.22-.81-17.22-1.8,7.71-1.8,17.22-1.8S229.82,381.15,229.82,382.15Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M227.81,382.15c0,.88-6.81,1.59-15.21,1.59s-15.21-.71-15.21-1.59,6.81-1.59,15.21-1.59S227.81,381.27,227.81,382.15Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M226.46,382.15c0,.8-6.21,1.45-13.86,1.45s-13.86-.65-13.86-1.45,6.21-1.45,13.86-1.45S226.46,381.35,226.46,382.15Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M226.46,382.15c0,.8-6.21,1.45-13.86,1.45s-13.86-.65-13.86-1.45,6.21-1.45,13.86-1.45S226.46,381.35,226.46,382.15Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M225.37,382.15c0,.74-5.72,1.34-12.77,1.34s-12.77-.6-12.77-1.34,5.72-1.34,12.77-1.34S225.37,381.41,225.37,382.15Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M224.44,382.15c0,.68-5.3,1.24-11.84,1.24s-11.84-.55-11.84-1.24,5.3-1.24,11.84-1.24S224.44,381.46,224.44,382.15Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M223.42,382.15c0,.63-4.85,1.13-10.83,1.13s-10.83-.51-10.83-1.13,4.85-1.13,10.83-1.13S223.42,381.52,223.42,382.15Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M222.16,382.15c0,.55-4.28,1-9.56,1s-9.56-.45-9.56-1,4.28-1,9.56-1S222.16,381.6,222.16,382.15Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M221.31,382.15c0,.5-3.9.91-8.71.91s-8.71-.41-8.71-.91,3.9-.91,8.71-.91S221.31,381.64,221.31,382.15Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M220.72,382.15c0,.47-3.64.85-8.12.85s-8.12-.38-8.12-.85,3.64-.85,8.12-.85S220.72,381.68,220.72,382.15Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M220.08,382.15c0,.43-3.35.78-7.48.78s-7.48-.35-7.48-.78,3.35-.78,7.48-.78S220.08,381.72,220.08,382.15Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M219.54,382.15c0,.4-3.11.73-6.94.73s-6.94-.33-6.94-.73,3.11-.73,6.94-.73S219.54,381.75,219.54,382.15Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M218.94,382.15c0,.37-2.84.66-6.34.66s-6.34-.3-6.34-.66,2.84-.66,6.34-.66S218.94,381.78,218.94,382.15Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M218.2,382.15c0,.32-2.51.59-5.6.59s-5.6-.26-5.6-.59,2.51-.59,5.6-.59S218.2,381.82,218.2,382.15Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M217.71,382.15c0,.3-2.29.54-5.11.54s-5.11-.24-5.11-.54,2.29-.53,5.11-.53S217.71,381.85,217.71,382.15Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M217,382.15c0,.25-2,.46-4.38.46s-4.38-.21-4.38-.46,2-.46,4.38-.46S217,381.89,217,382.15Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M216.21,382.15c0,.21-1.62.38-3.61.38s-3.61-.17-3.61-.38,1.62-.38,3.61-.38S216.21,381.94,216.21,382.15Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M215.09,382.15a12.05,12.05,0,0,1-5,0,6.28,6.28,0,0,1,2.49-.26A6.08,6.08,0,0,1,215.09,382.15Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M214.29,382.15a8,8,0,0,1-3.38,0,8,8,0,0,1,3.38,0Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M124.12,346.27c2.51,5.44,7.23,9.73,12.06,12.64l3.29,2,6.45,3.89,3.79,2.29c1,.61,2.67.4,3-.94s-.81-2.44-1.79-3.24-1.68-1.54-2.54-2.27c-1.8-1.55-3.51-3.19-5.3-4.75-.4-.34-.77-.73-1.19-1.06l1.41,1,3.44,2.49,4.34,3.14,4.11,3c1,.72,2,1.48,3,2.14s2.4.88,3.19-.05a2.33,2.33,0,0,0,.31-1.81,4.1,4.1,0,0,0-1.16-2.1c-.5-.46-1-.93-1.45-1.42a50.84,50.84,0,0,0-4.13-3.77c-1.55-1.32-3.09-2.65-4.65-3.95l-3.91-3.25c-.61-.51-1.22-1-1.86-1.51l0,0,18.35,14.4c1.22,1,4.22,2.57,5.51.47a3.88,3.88,0,0,0-.19-3,7.68,7.68,0,0,0-1.8-1.93c-1.35-1.23-2.64-2.5-4-3.68-2.87-2.42-5.72-4.85-8.68-7.17-.65-.51-1.29-1.06-2-1.55a68.23,68.23,0,0,0,6.92,5.11c2.74,1.87,4.49,3.42,6.64,4.69a4.7,4.7,0,0,0,2,.92,3.34,3.34,0,0,0,2.7-1c.69-1,0-2.95-1-3.76a106.33,106.33,0,0,0-14.17-10.88s-4.23-2.57-4.58-3c0,0,8.13,4.45,13.46,3.46,0,0,7-3.53-4.38-5.91,0,0-6.43-2.87-10.43-4.83a24.08,24.08,0,0,0-17-1.38s-7.44-4.58-9.37-6.2l-7.14,9.24S122.27,342.26,124.12,346.27Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M304.15,337.18c.5,6-1.49,12-4.25,16.94L298,357.46,294.33,364l-2.17,3.86c-.58,1-2.13,1.67-3.05.65s-.5-2.53,0-3.7.7-2.16,1.08-3.23c.8-2.23,1.48-4.51,2.27-6.74.18-.49.31-1,.51-1.51l-.72,1.58-1.77,3.87c-.74,1.62-1.49,3.25-2.22,4.87s-1.4,3.08-2.11,4.62c-.51,1.12-1,2.26-1.56,3.34s-1.65,1.95-2.8,1.53a2.33,2.33,0,0,1-1.16-1.42,4.17,4.17,0,0,1,0-2.4c.21-.65.39-1.29.55-2a52.39,52.39,0,0,1,1.73-5.32c.7-1.91,1.38-3.83,2.1-5.73.6-1.58,1.21-3.17,1.8-4.75.28-.74.55-1.5.87-2.23,0,0,0,0,0,0l-8.85,21.58c-.59,1.44-2.41,4.32-4.56,3.13a3.87,3.87,0,0,1-1.33-2.74,8,8,0,0,1,.61-2.57c.57-1.73,1.06-3.47,1.7-5.19,1.31-3.52,2.58-7.05,4-10.52.32-.77.59-1.56.94-2.31a68.92,68.92,0,0,1-3.5,7.86c-1.47,3-2.21,5.19-3.47,7.36a4.79,4.79,0,0,1-1.27,1.78,3.36,3.36,0,0,1-2.83.5c-1.11-.56-1.41-2.6-1-3.76A108.08,108.08,0,0,1,275,348s2.41-4.32,2.51-4.87c0,0-4.88,7.89-10,9.65,0,0-7.84.39.9-7.3,0,0,4.18-5.67,6.69-9.34a24.09,24.09,0,0,1,14.09-9.58s4.21-7.66,5.09-10L309.77,323S303.77,332.78,304.15,337.18Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M194.6,208.16s3.66,10.33-6.84,18.15c0,0,24,24.65,55.5,0,0,0-12-1.2-7.5-24.66Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M316.77,313.66,295,256.7c-4.84-14.19-17.25-22.77-30.21-28.08L243.62,220c-23.65,25.84-53.29,0-53.29,0-4.38,2.41-8.74,4.86-13.12,7.29-12.17,6.77-26.55,11.82-34.1,24.29l-34.67,60.75s3.17,22.83,12.12,28.62c0,0,2.54-13.95,21.16-12l-2.95-14.41,30.67-31.22,4.86,53H256l6.4-53,25.83,29.81-11.54,20.67c19.33-8,27.49,5.17,27.49,5.17s9.69-11.7,12.56-25.34"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M251.12,169.51c-.05-30.55-16.76-47.18-37.36-47.18S176.45,139,176.4,169.51c-1.18,0-7.35.44-3.84,7.45a19.81,19.81,0,0,1,4,10.46s1.33,3.16,3.31,1.71a60.86,60.86,0,0,0,21.28,27.66s13.94,9.14,24.28,1a51.56,51.56,0,0,0,22.7-28.38c1.67.56,2.76-2,2.76-2A19.81,19.81,0,0,1,255,177C258.47,170,252.31,169.53,251.12,169.51Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M251.52,169.66c-1.22,2.6-6.86,6.17-6.25,9.54h0c-.76-1.18.11-4.84,0-6.29a47.31,47.31,0,0,0-1.25-7.26c-1.21-5.11-2.71-9.69-5.68-14.06-3.5-5.15-7.47-8.53-14.32-8.19-4.12.21-10.31,1.2-11,6.18-3.51-8.35-18.53-8.23-23.51-1.31-2.92,4-4.11,8.6-4.8,13.44-.41,2.92-.58,5.88-1.14,8.75-.34,1.73-.6,5.28-1.55,6.44a11.38,11.38,0,0,0-5.61-7.4c-4.58-2.31-.44-24.84.54-28.19,4.72-16.08,18.78-25.47,34.9-27.17,8.1-.86,16.12-3,24.4-2.39a33.33,33.33,0,0,0-5.21,4.84c4.71-.76,9.16-2.24,14.18-1.86-2.66,2-1.44,4.93-2.77,7.85,5.83-.35,10.15,6.86,13.16,11-2.79-.74-5.43-2.18-8.2-3C259.69,134.15,255.21,161.81,251.52,169.66Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.32,220l-9.48,5.26s16.81,15.32,34.12,15.4h.56c17.5-.25,29.64-5.23,36.2-17.37l-8.1-3.3s-13.29,11.79-24.69,11.48C218.92,231.48,206.77,232.08,190.32,220Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M282.23,361.85a5.94,5.94,0,0,1-5.94,5.94H150.82a5.94,5.94,0,0,1-5.94-5.94V270.34a5.94,5.94,0,0,1,5.94-5.94H276.29a5.94,5.94,0,0,1,5.94,5.94Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M146.52,271.6v51.19c0,23.31,2.59,42.21,5.79,42.21H274.7c3.2,0,5.79-18.9,5.79-42.21V271.6Z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 165.45,
    y: 366.25,
    width: 18.97,
    height: 4.47
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 239.33,
    y: 366.25,
    width: 18.97,
    height: 4.47
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M130.93,372.53H296.6s-2.29,7.25-6.43,10H145.92S132.37,381.16,130.93,372.53Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M232,167.15a27.2,27.2,0,0,0-5.78,1c-.46.14-.92.3-1.36.47a29.48,29.48,0,0,1-18.57.17,18.06,18.06,0,0,0-2.1-.86h0a26.5,26.5,0,0,0-6.41-1.25c-16.07-1.25-18.67,5.46-16,13.4,2.4,7,6.21,10.65,15.08,10.65s13.38-2.4,15.08-10.65a11.65,11.65,0,0,0,.2-3.76,4.14,4.14,0,0,1,5.52-.08,11.51,11.51,0,0,0,.12,4.27c1.7,8.25,6.21,10.65,15.08,10.65s12.68-3.61,15.08-10.65C250.67,172.61,248.07,165.89,232,167.15Zm-22.16,13.09c-1.41,6.43-5.14,8.3-12.48,8.3s-10.5-2.81-12.48-8.3c-2.24-6.2-.08-11.44,13.22-10.46C205.41,170.32,211.3,173.53,209.84,180.24Zm35.07.43c-2,5.49-5.14,8.3-12.48,8.3s-11.07-1.87-12.48-8.3c-1.47-6.71,4.42-9.92,11.75-10.46C245,169.23,247.14,174.47,244.91,180.67Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 178.1 179.76 179.1 178.26 169.04 184.46 169.04 183.65 178.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.26 178.1 250.15 179.1 251.65 169.04 245.45 169.04 246.26 178.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesti);
export default __webpack_public_path__ + "static/media/testi.cc0c1cf87ef0e4ec8e9dfbe199ce8b30.svg";
export { ForwardRef as ReactComponent };